import React from "react";

function NewsIcon (props) {
    const { idAttribute, fill, classname, click } = props;

    return (
		<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill={ fill } id={ idAttribute } className={ classname } onClick={ click !== undefined ? click : null }><path d="m440.08 341.31c-1.66-2-3.29-4-4.89-5.93-22-26.61-35.31-42.67-35.31-118 0-39-9.33-71-27.72-95-13.56-17.73-31.89-31.18-56.05-41.12a3 3 0 0 1 -.82-.67c-8.69-29.1-32.47-48.59-59.29-48.59s-50.59 19.49-59.28 48.56a3.13 3.13 0 0 1 -.81.65c-56.38 23.21-83.78 67.74-83.78 136.14 0 75.36-13.29 91.42-35.31 118-1.6 1.93-3.23 3.89-4.89 5.93a35.16 35.16 0 0 0 -4.65 37.62c6.17 13 19.32 21.07 34.33 21.07h308.89c14.94 0 28-8.06 34.19-21a35.17 35.17 0 0 0 -4.61-37.66z"></path><path d="m256 480a80.06 80.06 0 0 0 70.44-42.13 4 4 0 0 0 -3.54-5.87h-133.78a4 4 0 0 0 -3.55 5.87 80.06 80.06 0 0 0 70.43 42.13z"></path></svg>
	);
}

export default NewsIcon;
